export default __webpack_public_path__ + "static/about_team-9d4b735390c17c04e62f0334581326c3.jpg";